import { gql } from "@apollo/client";

import { PaginationResponse } from "@regal-voice/ui";
import { Journey } from "Types/Journey";

export type GetJourneysResponse = {
    getJourneys: PaginationResponse<Journey>;
};

export const fetchJourneys = gql`
    query fetchJourneys($queryParams: QueryParams!) {
        getJourneys(queryParams: $queryParams) {
            hasMore
            items {
                id
                friendlyId
                name
                nodeId
                state
                flow
                updatedAt
                updatedBy
                createdAt
                createdBy
                finishedJourneys
                inProgressJourneys
                stateMachineArn
                triggerType
                version
                originalCreatedAt
                hidden
                tags {
                    id
                    name
                }
            }
        }
    }
`;
